import React, { FC, useEffect } from 'react'

// Hooks
import { useBanner } from 'containers/Banner'

// Components
import BannerCardList from 'modules/shares/components/BannerCardList'
import { UPGRADE_PERSONAL_WORKSPACE_BANNER_ID } from 'modules/workspace/components/WarningBanners/Banners'

// Types
import { WorkspaceMinimalFragment } from 'gqlTypes'

// Helpers
import { UPGRADE_PERSONAL_WORKSPACE_BANNER } from '../BannerCardList/Banners'

interface SharesWithBannersProps {
  workspace: WorkspaceMinimalFragment
}

/**
 * SharesWithBanners
 *
 * Renders the BannerCards in Non-Empty "All Documents" for both
 * Workspace and Personal Workspace
 */
const SharesWithBanners: FC<SharesWithBannersProps> = ({ workspace }) => {
  const { dismissBanner, items } = useBanner()

  useEffect(() => {
    const hasBanner = items.find(
      banner => banner.id === UPGRADE_PERSONAL_WORKSPACE_BANNER_ID
    )
    if (hasBanner) dismissBanner(UPGRADE_PERSONAL_WORKSPACE_BANNER_ID)
  }, [dismissBanner, items])

  const isPersonalWorkspace = workspace?.type === 'PERSONAL'

  const bannerCardList = []

  if (isPersonalWorkspace) {
    // BannerCards for Personal Workspaces
    bannerCardList.push(UPGRADE_PERSONAL_WORKSPACE_BANNER)
  } // else { // BannerCards for Workspaces }

  return <BannerCardList maxBanners={4} banners={bannerCardList} smallBanners />
}

export default SharesWithBanners
